<div *ngIf="store.rebalancing">
  <div class="mt-2 mb-4 flex">
    <div
      class="mr-1 w-1/2 border-2 border-yellow-400/20 rounded bg-gray-900 relative overflow-hidden"
    >
      <div
        *ngIf="
          store.step < rebalancingSteps.EXPIRED ||
          store.step === rebalancingSteps.IN_PROGRESS
        "
        class="absolute h-full bg-yellow-500/20 z-0"
        [style.width]="getExpirationPercentage() + '%'"
      ></div>
      <div class="z-10 px-4 py-2 flex justify-between items-center">
        <span class="text-gray-400"
          >{{ 'rebalancing.expires' | translate }}:</span
        >
        <ng-container
          *ngIf="store.rebalancing?.suggestedRefreshQuotesTimestamp"
        >
          <ng-container
            *ngIf="
              store.step < rebalancingSteps.EXPIRED ||
                store.step === rebalancingSteps.IN_PROGRESS;
              else noExpiryCountdown
            "
          >
            <span class="text-gray-400 z-10">
              {{
                expirationMilliseconds > 0
                  ? (expirationMilliseconds | date: 'mm:ss')
                  : ('rebalancing.expired' | translate)
              }}
            </span>
          </ng-container>
        </ng-container>
        <ng-template #noExpiryCountdown>
          <ng-container
            *ngIf="
              store.step === rebalancingSteps.EXPIRED;
              else inProgressOrFinished
            "
          >
            <div class="-my-0.5 flex items-center justify-between">
              <div class="alert-warning !m-0 !px-2 !py-0.5">
                <ng-icon
                  name="hero-exclamation-triangle-mini"
                  size="20"
                  class="text-gray-light"
                ></ng-icon>
                <span
                  class="text-sm text-gray-light"
                  [innerHtml]="'rebalancing.expiredInfo' | translate"
                >
                </span>
              </div>
            </div>
          </ng-container>
          <ng-template #inProgressOrFinished>
            <span class="text-sm text-gray-light">-</span>
          </ng-template>
        </ng-template>
      </div>
    </div>
    <div
      class="ml-1 w-1/2 border-2 border-gray-800 rounded bg-gray-900 p-2 {{
        store.step === rebalancingSteps.REFETCH_QUOTES ? 'animate-pulse' : ''
      }}"
    >
      <div class="px-2 flex justify-between items-center">
        <span class="text-gray-400"
          >{{ 'rebalancing.refreshIn' | translate }}:</span
        >
        <span
          *ngIf="
            store.step < rebalancingSteps.EXPIRED &&
              store.rebalancing?.suggestedRefreshQuotesTimestamp;
            else noRefresh
          "
          class="text-gray-400"
        >
          {{
            refreshMilliseconds > 0
              ? (refreshMilliseconds | date: 'mm:ss')
              : ('rebalancing.refreshing' | translate)
          }}
        </span>
        <ng-template #noRefresh>
          <span class="text-gray-400">-</span>
        </ng-template>
      </div>
    </div>
  </div>
</div>
